import { CROSS_BREAKPOINT, LARGER } from './breakpoint-controller'

var win,
	mainNav,
	mainMenu, mainMenuToggleButton, subMenus,
	subMenuToggles,menuItem,
	utilityNav,secondaryMenu;
var cachedWidth = $(window).width();
function onDocumentReady() {
	win 				 = $(window);
	mainNav              = $('#main-nav');
	mainMenu             = $('#main-menu');
	mainMenuToggleButton = $('#main-menu-toggle');
	subMenus 	         = $('.sub-menu');
	subMenuToggles       = $('.sub-menu-toggle');
	menuItem 			 = $('#main-nav .menu-item');
	utilityNav			 = $('#header-top');
	secondaryMenu		 = $('#secondary-menu').find('.menu-item');

	if (Modernizr.touchevents) {
		mainNav.addClass('main-nav-has-touch');
		mainMenu.addClass('main-menu-has-touch');
	} else {
		mainNav.addClass('main-nav-no-touch');
		mainMenu.addClass('main-menu-no-touch');
	}

	mainNavInit();

	menuReset();

	$(window).on("load resize", function() {
		var newWidth = $(window).width();
		if(newWidth !== cachedWidth){
            menuReset();
        }
	});

	$(document).on(CROSS_BREAKPOINT, mainNavInit);
	$(document).on(CROSS_BREAKPOINT, menuReset);
	mainMenuToggleButton.on('click', function(event) {
		event.preventDefault();
		mainMenuToggle();
	});

	subMenuToggles.on('click', function(event) {
		event.preventDefault();
		subMenuToggle(this);
	});

	menuItem.hover(function () {
		if (win.width() >= LARGER) {
			if(!mainMenu.hasClass('main-menu-has-touch')){
		 		$(this).toggleClass('active-menu');
				let menu = $(this).find('.sub-menu').first();
				var menupos = 0;
				if(menu){
					menupos = menu.offset();
				    if (menupos && menupos.left + menu.width() > $(window).width()) {
				        menu.addClass('menu-offscreenright');
				    }else{
						menuItem.removeClass('menu-offscreenleft');
					}
				}
			}
		}
	});
}

/**
 * Initialize main nav depending on viewport width
 */
function mainNavInit(e, breakpoint) {
	menuReset();
	if (breakpoint >= LARGER) {
		mainNavInitLarge();
	} else {
		mainNavInitSmall();
	}

}

/**
 * Initialize main nav for small viewports
 */
function mainNavInitSmall() {
	subMenus.attr('aria-hidden', true);
	mainMenu.removeClass('active').attr('aria-hidden', true);
	subMenuToggles.removeClass('active').attr('aria-expanded', false);
	utilityNav.appendTo('.main-menu').addClass('mobile-nav-contact');
	secondaryMenu.appendTo('.main-menu').find('a').addClass('button-slide button-slide-large');

}

/**
 * Initialize main nav for large viewports
 */
function mainNavInitLarge() {
	mainMenu.show().removeClass('active');
	subMenuToggles.removeClass('active');
	subMenus.show().removeAttr('style');
	utilityNav.appendTo('.header-top .container').removeClass('mobile-nav-contact');
	secondaryMenu.appendTo('.secondary-menu').find('a').removeClass('button-slide button-slide-large');
}

/**
 * Toggle main menu
 */
function mainMenuToggle() {

	if (mainMenu.hasClass('active')) {
		mainMenu.removeClass('active').attr('aria-hidden', true);
		subMenus.each(function() {
			if(!$(this).closest('.menu-item-top-level').hasClass('mega-nav')){
				$(this).removeClass('active').attr('aria-hidden', true);
			}
			subMenus.attr('aria-hidden', true).removeClass('active');
		});
		mainMenuToggleButton.attr('aria-expanded', 'false').removeClass('menu-open');
		subMenuToggles.removeClass('active').attr('aria-expanded', false);
	} else {
		mainMenu.addClass('active').attr('aria-hidden', false);
		mainMenuToggleButton.attr('aria-expanded', 'true').addClass('menu-open');
	}

}

/**
 * Toggle submenus
 */
function subMenuToggle(el) {

	var toggle       = $(el),
		thisSubMenu  = toggle.closest('.menu-item').find('.sub-menu').first();
		if (toggle.hasClass('active')) {
	        thisSubMenu.removeClass('active').attr('aria-hidden', true);
	        toggle.removeClass('active').attr('aria-expanded', false);
			toggle.closest('.menu-item').find('.sub-menu').removeClass('active').attr('aria-hidden', true);
			toggle.closest('.menu-item').find('.sub-menu').find('.sub-menu-toggle').removeClass('active').attr('aria-expanded', false);
			if (win.width() >= LARGER) {
				toggle.closest('.menu-item').removeClass('active-menu');
			}
	    } else {
			subMenus.removeClass('active').attr('aria-expanded', false);
			subMenuToggles.removeClass('active').attr('aria-expanded', false);
	        toggle.addClass('active').attr('aria-expanded', true);
	        thisSubMenu.addClass('active').attr('aria-hidden', false);
			if (win.width() >= LARGER) {
				menuItem.removeClass('active-menu');
				toggle.closest('.menu-item').addClass('active-menu');
			}
	    }
}

function menuReset(e, breakpoint){
	mainMenu.removeClass('active').attr('aria-hidden', true);
	subMenus.removeClass('active').attr('aria-hidden', true);
	mainMenuToggleButton.removeClass('menu-open').attr('aria-expanded', 'false');
	subMenuToggles.removeClass('active').attr('aria-expanded', false);
}

$(onDocumentReady);



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/mainnav-controller.js